<app-artist-list-item [page]="artist" [darkMode]="true"></app-artist-list-item>
